<template>
  <div class="w-full border shadow-xl justify-center max-w-xs min-w-full flex flex-col">
    <div class="flex flex-col">
      <!-- Header: -->
      <div class="flex flex-col h-28 items-center pt-6 bg-secondary">
        <span class="text-lg block w-full text-center px-6 truncate">{{ tabletItem.name }}</span>
      </div>
      <div class="flex flex-col relative">
        <div
          :class="[
            'rounded-full p-5 border-2 z-10 self-center absolute -top-11',
            tabletItem.tour_count ? 'has_tours' : 'bg-white',
            !tabletItem.is_active ? 'is_inactive' : '',
          ]"
        >
          <base-icon icon="tablet" class="text-5xl" />
        </div>
      </div>
      <!-- Body: -->
      <div class="bg-white pt-16 p-5">
        <div class="flex space-x-2 2xl:space-x-5 w-full mb-2">
          <div class="flex justify-between w-1/2 items-center border p-1.5 rounded">
            <span class="text-sm truncate text-gray-400 pr-1"> Android version </span>
            <span class="text-sm px-1">
              {{ tabletItem.android_version || 'N/A' }}
            </span>
          </div>
          <div class="flex justify-between space-x-2 w-1/2 items-center border p-1.5 rounded">
            <span class="text-sm text-gray-400 truncate">Status</span>
            <span
              :class="[
                'text-xs px-1.5  text-white rounded-sm',
                tabletItem.is_active ? 'bg-green-400' : 'bg-gray-400',
              ]"
            >
              {{ tabletItem.is_active ? 'Active' : 'Inactive' }}
            </span>
          </div>
        </div>
        <div class="flex flex-col space-y-2 rounded p-3 border">
          <div class="flex flex-col space-y-1">
            <span class="text-sm text-gray-400"> Android ID </span>
            <span class="text-sm font-base truncate">
              {{ tabletItem.android_id }}
            </span>
          </div>
          <div class="flex flex-col space-y-1">
            <span class="text-sm text-gray-400">Company Name</span>
            <span class="text-sm text-gray-900 mt-1">{{ tabletItem.company_name }}</span>
          </div>

          <div class="flex flex-col space-y-1">
            <span class="text-sm text-gray-400">Device Model</span>
            <span class="text-sm text-gray-900">{{ tabletItem.model || 'N/A' }}</span>
          </div>
        </div>
      </div>
      <!-- Buttons: -->
      <div v-if="actions" class="flex items-center justify-between w-full bg-white py-2">
        <base-button
          context="secondary"
          size="sm"
          :disabled="tabletItem.tour_count === 0"
          class="ml-7 mb-2"
          @click="$emit('openDrawer', tabletItem)"
        >
          {{ toursButton }}
        </base-button>
        <a-popover
          overlayClassName="no-padding"
          :visible="clicked === tabletItem.android_id"
          @visibleChange="e => (clicked = e ? tabletItem.android_id : '')"
          placement="bottomLeft"
          trigger="click"
          arrowPointAtCenter
          class="mr-7 mb-2"
        >
          <template slot="content">
            <base-button
              size="sm"
              context="outline"
              class="w-full p-0.5"
              :disabled="!tabletItem.is_active"
              @click="deactivateTablet(tabletItem)"
            >
              Deactivate</base-button
            >
            <base-button
              size="sm"
              context="outline"
              class="w-full p-0.5"
              :disabled="tabletItem.is_active"
              @click="deleteTablet(tabletItem)"
            >
              Delete</base-button
            >
          </template>
          <base-button-icon icon="more" tooltip="Actions" :loading="loading" />
        </a-popover>
      </div>
    </div>
  </div>
</template>

<script>
import {BaseIcon, BaseButton, BaseButtonIcon} from '@/components/base'
import Popover from 'ant-design-vue/lib/popover'
import fileExport from '@/state/helpers/fileExport.js'
export default {
  name: 'TabletsCardItem',
  components: {
    BaseIcon,
    BaseButton,
    BaseButtonIcon,
    'a-popover': Popover,
  },
  props: {
    tabletItem: {
      type: Object,
      required: true,
    },
    actions: {
      type: Boolean,
    },
  },
  data() {
    return {
      showModalWindow: false,
      showTourModalWindow: false,
      showTours: false,
      clicked: '',
      isExporting: false,
      loading: false,
    }
  },
  computed: {
    toursButton() {
      return this.tabletItem.tour_count === 0
        ? 'No assigned tours'
        : this.tabletItem.tour_count === 1
        ? 'Show 1 assigned tour'
        : `Show ${this.tabletItem.tour_count} assigned tours`
    },
  },
  methods: {
    async deleteTablet(item) {
      this.clicked = ''
      let payload = item.uuid
      if (
        confirm(
          this.$t(`mygwf.components.Confirmation.tablet_confirm_delete`, {
            name: item.name,
            id: item.android_id,
          })
        )
      ) {
        try {
          this.loading = true
          await this.$store.dispatch('tablets/deleteTablet', {payload})
          this.loading = false
          this.$emit('delete')
          await this.$store.dispatch('app/notification', {
            type: 'success',
            group: 'app',
            text: `deleted`,
          })
        } catch (error) {
          console.log(error)
        }
      }
    },
    async deactivateTablet(item) {
      this.clicked = ''
      let payload = item.uuid
      this.loading = true
      let tourList = {}

      if (item.tour_count) {
        tourList = await this.$store.dispatch('tablets/getAssignedTours', payload)
      }

      if (
        tourList.results &&
        tourList.results.find(tour => tour.state === 'Assigned' || tour.state === 'In Progress')
      ) {
        alert('Cannot deactivate tablet with active tours.') //TODO: create translation/ alert modal
        await this.$store.dispatch('app/notification', {
          type: 'error',
          group: 'app',
          text: `deactivated`,
        })
        this.loading = false
        return
      }

      if (
        confirm(
          this.$t(`mygwf.components.Confirmation.tablet_confirm_deactivate`, {
            name: item.name,
            id: item.android_id,
          })
        )
      ) {
        try {
          await this.$store.dispatch('tablets/deactivateTablet', {payload})
          await this.$store.dispatch('app/notification', {
            type: 'success',
            group: 'app',
            text: `deactivated`,
          })
        } catch (error) {
          console.log(error)
          await this.$store.dispatch('app/notification', {
            type: 'error',
            group: 'app',
            text: `deactivated`,
          })
        } finally {
          this.loading = false
        }
      }
    },
  },
}
</script>

<style>
.no-padding .ant-popover-inner-content {
  padding: 0;
}
.has_tours {
  @apply bg-blue-400 text-white !important;
}
.is_inactive {
  @apply bg-gray-500 text-white !important;
}
</style>
